var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24424_3484)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 32,
    height: 32,
    rx: 5,
    fill: "#0F5EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25 12.75H12.75C12.3522 12.75 11.9706 12.908 11.6893 13.1893C11.408 13.4706 11.25 13.8522 11.25 14.25V27.75C11.25 28.1478 11.408 28.5294 11.6893 28.8107C11.9706 29.092 12.3522 29.25 12.75 29.25H29.25C29.6478 29.25 30.0294 29.092 30.3107 28.8107C30.592 28.5294 30.75 28.1478 30.75 27.75V14.25C30.75 13.8522 30.592 13.4706 30.3107 13.1893C30.0294 12.908 29.6478 12.75 29.25 12.75ZM21 24C19.8069 23.9988 18.663 23.5243 17.8194 22.6806C16.9757 21.837 16.5012 20.6931 16.5 19.5C16.5 19.3011 16.579 19.1103 16.7197 18.9697C16.8603 18.829 17.0511 18.75 17.25 18.75C17.4489 18.75 17.6397 18.829 17.7803 18.9697C17.921 19.1103 18 19.3011 18 19.5C18 20.2956 18.3161 21.0587 18.8787 21.6213C19.4413 22.1839 20.2044 22.5 21 22.5C21.7956 22.5 22.5587 22.1839 23.1213 21.6213C23.6839 21.0587 24 20.2956 24 19.5C24 19.3011 24.079 19.1103 24.2197 18.9697C24.3603 18.829 24.5511 18.75 24.75 18.75C24.9489 18.75 25.1397 18.829 25.2803 18.9697C25.421 19.1103 25.5 19.3011 25.5 19.5C25.4988 20.6931 25.0243 21.837 24.1806 22.6806C23.337 23.5243 22.1931 23.9988 21 24ZM12.75 15.75V14.25H29.25V15.75H12.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24424_3484",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_24424_3484"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24424_3484"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24424_3484",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingActive);
export default __webpack_public_path__ + "static/media/marketingActive.5920cb61d7a8673c9ffb5a4c792fe450.svg";
export { ForwardRef as ReactComponent };